import { createToast } from "./toasts";

function deleteListItem(button) {
  var item = button.closest(".list-group-item");
  var list = item.parentNode;

  //   If this is the last item in the list, don't delete it
  if (list.querySelectorAll(".list-group-item").length === 1) {
    createToast("danger", "Error", "You must have at least one item.");
    return;
  }

  list.removeChild(item);
  updateListDataFieldValue(list);
  createToast("success", "Item deleted", "The item has been deleted.");
}

function addListItem(button) {
  var list = button.closest(".input-group").querySelector(".list-group");
  var item = list.querySelector(".list-group-item").cloneNode(true);
  item.querySelector("input").value = "";
  item.querySelector("select").selectedIndex = 0;

  //   add the delete event listener to the new item
  item
    .querySelector(".delete-list-item-btn")
    .addEventListener("click", function (event) {
      event.preventDefault();

      deleteListItem(item.querySelector(".delete-list-item-btn"));
    });

  item
    .querySelectorAll(".data-list-text, .data-list-score")
    .forEach(function (input) {
      input.addEventListener("change", listItemUpdated);
    });

  list.appendChild(item);
}

function listItemUpdated(event) {
  var input = event.target;
  var list = input.closest(".list-group");

  updateListDataFieldValue(list);
}

function updateListDataFieldValue(list) {
  console.log(list);
  // Find custom data attributes on the list
  var dataAttributes = list.dataset;

  var data = [];
  list.querySelectorAll(".list-group-item").forEach(function (item) {
    var itemData = {};
    itemData["text"] = item.querySelector(".data-list-text").value;
    itemData["score"] = item.querySelector(".data-list-score").value;
    data.push(itemData);

    // Commented out below text becasue I dont think we need it and it caused some issues anyways
    // Push the item data if we have text, OR if we have the dataattribute "onlyScore" set to true
    // if (itemData["text"] || dataAttributes.onlyScore) {

    // }
  });

  var hiddenInput = list
    .closest(".input-group")
    .querySelector(".datalistinputwidget");

  hiddenInput.value = JSON.stringify(data);

  //   Trigger the change event on the hidden input
  var event = new Event("change");
  hiddenInput.dispatchEvent(event);
}

//   Add event listeners
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".add-list-item-btn").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      addListItem(button);
    });
  });

  document.querySelectorAll(".delete-list-item-btn").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      deleteListItem(button);
    });
  });

  document
    .querySelectorAll(".data-list-text, .data-list-score")
    .forEach(function (input) {
      input.addEventListener("change", listItemUpdated);
    });
});
